import nodeFetch, { RequestInit as NodeRequestInit } from 'node-fetch'
import isServerSide from '@bt-react/libs/isServerSide'
import HttpsProxyAgent from 'https-proxy-agent'

/**
 * Returns a proxy if we're server-side and not in prod
 */
export function getProxy(): HttpsProxyAgent.HttpsProxyAgent | undefined {

  if (
    !process.env.PROXY_HOST ||
    !process.env.PROXY_PORT
  ) return
  return HttpsProxyAgent(`http://${process.env.PROXY_HOST}:${process.env.PROXY_PORT}`)

}

export interface FetchOptions {
  includeCredentials?: boolean
  withProxy?: boolean
  headers?: any
  method?: string,
  body?: string,
  timeout?: number
}

const defaultOptions: FetchOptions = {
  includeCredentials: false,
  withProxy: isServerSide,
  timeout: 9000
}

export const getApiClientValue = () => {
  return typeof document !== 'undefined' ? 'react-player-page-browser' : 'react-player-page-server'
}

/**
 * 
 * @param apiLabel A name to add to log entries to identify the API
 * @param url The URL to call
 * @param includeCredentials Should we pass cookies to API [Only applies client-side]
 */
async function _fetch(
  url: string,
  {
    includeCredentials, withProxy, headers,
    method, body, timeout
  }: FetchOptions = defaultOptions
): Promise<Response> {

  let options
  let controllerId

  if (withProxy) {

    (options as NodeRequestInit) = {
      method,
      body,
      headers: {
        Accept: 'application/json',
        'BrightTALK-API-Client': getApiClientValue(),
        ...headers
      },
      agent: getProxy()
    }

  }
  else {

    let controller

    if (timeout) {

      controller = new AbortController()
      setTimeout(() => controller.abort(), timeout);

    }

    (options as RequestInit) = {
      method,
      body,
      headers: {
        Accept: 'application/json',
        'BrightTALK-API-Client': getApiClientValue(),
        ...headers
      },
      credentials: includeCredentials ? 'include' : 'omit',
      ...timeout && { signal: controller.signal }
    }

  }

  let call

  try {

    if (withProxy) {

      call = await nodeFetch(url, options)

    }
    else {

      call = await fetch(url, options)
      timeout && clearTimeout(controllerId);

    }

  }
  catch (e) {

  }

  return call as Response

}

export default _fetch
